import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LocalStorage } from 'ngx-store';


@Injectable({
    providedIn: 'root'
  })
  export class AdminService {

    api: string = environment.apiUrl;
    headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    @LocalStorage('loggedUser') loggedUser: any;
    lan = localStorage.getItem("lan")


    constructor(private http: HttpClient) { }

    async getAllCompletedTasks(): Promise<any> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token });
        return await this.http
            .get(this.api + `/tasks/all_completed_tasks`, { headers, observe: 'response' })
            .toPromise();
    }

    async getNoVoucherUsers(): Promise<any> {
      const headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token });
      return await this.http
          .get(this.api + `/users/noVoucherUsers`, { headers, observe: 'response' })
          .toPromise();
  }

    async getAllWords(): Promise<any> {
      const headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token });
      return await this.http
          .get(this.api + `/memory_experiment/allWords`, { headers, observe: 'response' })
          .toPromise();
  }


  async getAllWordsAndOld(): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token });
    return await this.http
        .get(this.api + `/memory_experiment/allWordsandOldWords`, { headers, observe: 'response' })
        .toPromise();
}

    async getBlocks(): Promise<any> {
      const headers = new HttpHeaders({'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token});
      console.log(this.api + `memory_experiment/words?language=`+this.lan)
      return await this.http
          .get(this.api + `/memory_experiment/words?language=`+this.lan, {headers, observe: 'response'})
          .toPromise();
  }
    async getQuestionnaireDataByTypeAndUser(type, user_id_for_data): Promise<any> {
      const headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token });
      return await this.http
          .get(this.api + `/collected-data/questionnaire/` + type + `/`+ user_id_for_data, { headers, observe: 'response' })
          .toPromise();
  }
  async getQuestionnaireDataByType(type): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token });
    return await this.http
        .get(this.api + `/collected-data-by-ques/questionnaire/` + type , { headers, observe: 'response' })
        .toPromise();
}
  async getTaskDataByTypeAndUser(type, user_id_for_data): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token });
    return await this.http
        .get(this.api + `/collected-data/task/` + type + `/`+ user_id_for_data, { headers, observe: 'response' })
        .toPromise();
}

  async getTaskDataByType(type: string, attempt: number = 0): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token });
    return await this.http
      .get(this.api + `/collected-data-by-task/task/` + type + `/` + attempt, { headers, observe: 'response' })
      .toPromise();
  }
  async getUsersIdAndEmail(): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token });
    return await this.http
      .get(this.api + `/collected-data-by-users/`, { headers, observe: 'response' })
      .toPromise();
  }
  async checkVoucher(user_email): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token });
    const user_email2=user_email.split("_")[0]
    return await this.http
      .put(this.api +`/users/checkvoucher/`+user_email2, { headers, responseType: 'text', observe: 'response' })
      .toPromise();
  }
  async getCheckedUsers(): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token });
    return await this.http
      .get(this.api + `/users/checkedUsers`, { headers, observe: 'response' })
      .toPromise();
  }
  async getAdmins(): Promise<any> {
    //const headers = new HttpHeaders({'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token});
    return this.http
        .get(`${this.api}/users/admin`, {headers: this.headers , observe: 'response' })
        .toPromise();
  }

  async getSubjectId(): Promise<any> {
    return this.http
      .get(`${this.api}/users/subjectId`, {headers: this.headers , observe: 'response' })
      .toPromise();
  }

  async getBlockedUsers(): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token });
    return await this.http
        .get(this.api + `/users/blockedUsers`, { headers, observe: 'response' })
        .toPromise();
  }

  async getActiveUsers(): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token });
    return await this.http
        .get(this.api + `/users/activeUsers`, { headers, observe: 'response' })
        .toPromise();
  }

  async unblockUser(user_id): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token });
    return await this.http
      .put(this.api +`/users/unblock/`+user_id, { headers, observe: 'response' })
      .toPromise();
  }

  async extendUser(user_id, time): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token });
    return await this.http
      .put(this.api +`/users/extend/`+user_id+`/`+time, { headers, observe: 'response' })
      .toPromise();
  }
  async uploadFACoefficientData(jsonData): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token });
    try {
      const response = await this.http
        .put(this.api + '/tasks/updateFACoefficientData', jsonData, { headers, observe: 'response' })
        .toPromise();

      return response;
    } catch (error) {
      // Handle errors here
      console.error('Error uploading FA coefficient data:', error);
      throw error;
    }
  }

  async getAttemptsList(search: string): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token });
    return await this.http
      .get(this.api + `/users/list-attempts/` + encodeURIComponent(search), { headers, observe: 'response' })
      .toPromise();
  }

  async createNewAttempt(userId: string): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token });
    return await this.http
      .post(this.api + `/users/create-new-attempt/` + userId, {}, { headers, observe: 'response', responseType: 'text' })
      .toPromise();
  }

}


